import { CheckableFieldComponent } from "./chunk-FPLBAJNJ.js";
import { Checkbox_default } from "./chunk-3HL27OQ6.js";
import { Icon_default } from "./chunk-HALE5GZ6.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckboxField/CheckboxField.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var CheckboxField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      label,
      description,
      badge,
      secondaryAction,
      variant,
      validation,
      validationMessage,
      suffix,
      icon,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "description", "badge", "secondaryAction", "variant", "validation", "validationMessage", "suffix", "icon", "className"]);
  return /* @__PURE__ */jsxs(CheckableFieldComponent, {
    id,
    name,
    label,
    description,
    badge,
    secondaryAction,
    variant: variant === "multiline" ? "primary" : variant,
    validation,
    validationMessage,
    className: clsx("pd:checkbox-field", variant === "multiline" && "pd:checkbox-field--multiline", className),
    children: [/* @__PURE__ */jsx(CheckableFieldComponent.Input, __spreadValues({
      ref,
      as: Checkbox_default,
      className: "pd:checkbox-field__input"
    }, rest)), /* @__PURE__ */jsx(CheckableFieldComponent.Wrap, {
      className: "pd:checkbox-field__wrap",
      children: variant === "multiline" ? /* @__PURE__ */jsxs(Fragment, {
        children: [/* @__PURE__ */jsxs("div", {
          className: "pd:checkbox-field__wrap-inner",
          children: [/* @__PURE__ */jsx(CheckableFieldComponent.Label, {
            className: "pd:checkbox-field__label"
          }), /* @__PURE__ */jsx(CheckableFieldComponent.SecondaryAction, {
            className: "pd:checkbox-field__secondary-action"
          }), /* @__PURE__ */jsx(CheckableFieldComponent.Badge, {
            className: "pd:checkbox-field__badge"
          }), /* @__PURE__ */jsx(CheckableFieldComponent.Validation, {
            className: "pd:checkbox-field__validation"
          }), /* @__PURE__ */jsx(CheckableFieldComponent.Description, {
            className: "pd:checkbox-field__description"
          })]
        }), icon && /* @__PURE__ */jsx(Icon_default, {
          icon,
          size: "xl"
        })]
      }) : /* @__PURE__ */jsxs(Fragment, {
        children: [/* @__PURE__ */jsx(CheckableFieldComponent.Label, {
          className: "pd:checkbox-field__label"
        }), /* @__PURE__ */jsx(CheckableFieldComponent.Description, {
          className: "pd:checkbox-field__description"
        }), /* @__PURE__ */jsx(CheckableFieldComponent.SecondaryAction, {
          className: "pd:checkbox-field__secondary-action"
        }), /* @__PURE__ */jsx(CheckableFieldComponent.Badge, {
          className: "pd:checkbox-field__badge"
        }), /* @__PURE__ */jsx(CheckableFieldComponent.Validation, {
          className: "pd:checkbox-field__validation"
        }), suffix && /* @__PURE__ */jsx("span", {
          className: "pd:ml-auto",
          children: suffix
        })]
      })
    })]
  });
});
var CheckboxField_default = CheckboxField;
export { CheckboxField_default };